var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuadroL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_2",
    "data-name": "Capa 2",
    viewBox: "0 0 873.57 545.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #f2f2f2;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-5 {\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-7 {\n        fill: gray;\n      }\n\n      .cls-2, .cls-3, .cls-8, .cls-9 {\n        font-family: Montserrat-Bold, Montserrat;\n        font-weight: 700;\n      }\n\n      .cls-2, .cls-10, .cls-6 {\n        font-size: 22px;\n      }\n\n      .cls-11 {\n        fill: #de5562;\n      }\n\n      .cls-3, .cls-8 {\n        font-size: 20px;\n      }\n\n      .cls-12 {\n        fill: #bf2e3b;\n      }\n\n      .cls-8 {\n        fill: #fffdfd;\n      }\n\n      .cls-13 {\n        fill: #980a17;\n      }\n\n      .cls-14 {\n        letter-spacing: 0em;\n      }\n\n      .cls-15 {\n        letter-spacing: 0em;\n      }\n\n      .cls-16 {\n        font-size: 24px;\n      }\n\n      .cls-17 {\n        letter-spacing: 0em;\n      }\n\n      .cls-18 {\n        letter-spacing: 0em;\n      }\n\n      .cls-19 {\n        letter-spacing: 0em;\n      }\n\n      .cls-20 {\n        letter-spacing: 0em;\n      }\n\n      .cls-21 {\n        letter-spacing: 0em;\n      }\n\n      .cls-22 {\n        fill: #666;\n      }\n\n      .cls-23 {\n        letter-spacing: 0em;\n      }\n\n      .cls-24 {\n        letter-spacing: 0em;\n      }\n\n      .cls-25 {\n        letter-spacing: 0em;\n      }\n\n      .cls-10 {\n        font-family: Montserrat-Regular, Montserrat;\n      }\n\n      .cls-26 {\n        fill: url(#Degradado_sin_nombre_3);\n      }\n\n      .cls-9 {\n        font-size: 24.22px;\n      }\n\n      .cls-5 {\n        stroke: gray;\n      }\n\n      .cls-27 {\n        letter-spacing: -.07em;\n      }\n\n      .cls-28 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-29 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-30 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-31 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-32 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-33 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-34 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-35 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-36 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-37 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-38 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-39 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-40 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-41 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-42 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-43 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-44 {\n        letter-spacing: 0em;\n      }\n\n      .cls-45 {\n        letter-spacing: 0em;\n      }\n\n      .cls-46 {\n        letter-spacing: 0em;\n      }\n\n      .cls-47 {\n        letter-spacing: 0em;\n      }\n\n      .cls-48 {\n        letter-spacing: 0em;\n      }\n\n      .cls-49 {\n        letter-spacing: 0em;\n      }\n\n      .cls-50 {\n        letter-spacing: 0em;\n      }\n\n      .cls-51 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-52 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-53 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-54 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-55 {\n        letter-spacing: 0em;\n      }\n\n      .cls-56 {\n        letter-spacing: 0em;\n      }\n\n      .cls-57 {\n        letter-spacing: 0em;\n      }\n\n      .cls-58 {\n        letter-spacing: 0em;\n      }\n\n      .cls-59 {\n        letter-spacing: 0em;\n      }\n\n      .cls-60 {\n        letter-spacing: 0em;\n      }\n\n      .cls-61 {\n        letter-spacing: 0em;\n      }\n\n      .cls-62 {\n        letter-spacing: 0em;\n      }\n\n      .cls-6 {\n        font-family: Montserrat-SemiBold, Montserrat;\n        font-weight: 600;\n      }\n\n      .cls-63 {\n        letter-spacing: .02em;\n      }\n\n      .cls-64 {\n        letter-spacing: .02em;\n      }\n\n      .cls-65 {\n        letter-spacing: .03em;\n      }\n\n      .cls-66 {\n        letter-spacing: 0em;\n      }\n\n      .cls-67 {\n        letter-spacing: 0em;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3",
    "data-name": "Degradado sin nombre 3",
    x1: 724.87,
    y1: 545.41,
    x2: 724.87,
    y2: 43.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed7850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#c5674a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8b4e43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5b393d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#362938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1b1d34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0a1632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#051432"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M873.57,487.24h-297.4v-10.73h297.4v10.73ZM873.57,512.41V60.13c0-5.81-11.19-17-25-17h-247.4c-13.81,0-25,11.19-25,17v452.28c0,21.81,11.19,33,25,33h247.4c13.81,0,25-11.19,25-33Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M268.8,487.24v33.17c0,13.81,11.19,25,25,25h247.4c13.81,0,25-11.19,25-25v-33.17h-297.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M269.8,475.51V68.13c0-13.23,10.77-24,24-24h247.4c13.23,0,24,10.77,24,24v407.38h-295.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M541.2,45.13c12.68,0,23,10.32,23,23v406.38h-293.4V68.13c0-12.68,10.32-23,23-23h247.4M541.2,43.13h-247.4c-13.81,0-25,11.19-25,25v408.38h297.4V68.13c0-13.81-11.19-25-25-25h0Z"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(41.85 136.89)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ejecuci\xF3n"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 46
  }, "Fl"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 21.94,
    y: 46
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.26,
    y: 46
  }, "xibilid"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 109.03,
    y: 46
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 123.45,
    y: 46
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 0,
    y: 92
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-51",
    x: 16.87,
    y: 92
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 26.42,
    y: 92
  }, "ecisi\xF3n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 0,
    y: 138
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.82,
    y: 138
  }, "omplia"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 101.54,
    y: 138
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-59",
    x: 117.96,
    y: 138
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 131.47,
    y: 138
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 0,
    y: 184
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.91,
    y: 184
  }, "scalabilid"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 129.86,
    y: 184
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 144.29,
    y: 184
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 0,
    y: 230
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 17.18,
    y: 230
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 31.54,
    y: 230
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 47.78,
    y: 230
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.21,
    y: 230
  }, "cit"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 92.54,
    y: 230
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 106.97,
    y: 230
  }, "ci\xF3n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 0,
    y: 276
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.77,
    y: 276
  }, "alor "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 68.35,
    y: 276
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 85.8,
    y: 276
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-52",
    x: 102.36,
    y: 276
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 111.91,
    y: 276
  }, "eg"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 143.16,
    y: 276
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 157.58,
    y: 276
  }, "do"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 0,
    y: 322
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.82,
    y: 322
  }, "os"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 44.09,
    y: 322
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 53.59,
    y: 322
  }, "o")), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(292.14 136.89)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-50",
    x: 0,
    y: 0
  }, "8"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.95,
    y: 0
  }, "x5"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 0,
    y: 46
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.66,
    y: 46
  }, "dapt"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 67.41,
    y: 46
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 80.43,
    y: 46
  }, "ci\xF3n lenta"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 0,
    y: 92
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.51,
    y: 92
  }, "osibilid"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 93.57,
    y: 92
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 106.59,
    y: 92
  }, "d de E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 175.95,
    y: 92
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 184.6,
    y: 92
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 193.14,
    y: 92
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 206.93,
    y: 92
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 215.47,
    y: 92
  }, "es"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 138
  }, "Bajo ni"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 75.96,
    y: 138
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 87.56,
    y: 138
  }, "el"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 184
  }, "NO escalable"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 230
  }, "Semanas / Meses"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 276
  }, "Bajo (ta"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 84.3,
    y: 276
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 92.84,
    y: 276
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 105.8,
    y: 276
  }, "as "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 135.3,
    y: 276
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 143.83,
    y: 276
  }, "epetiti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 215.03,
    y: 276
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 226.6,
    y: 276
  }, "as)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 322
  }, "$$$$$$$")), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(602.58 136.89)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 0,
    y: 0
  }, "24"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 27.08,
    y: 0
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    x: 39.58,
    y: 0
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-47",
    x: 0,
    y: 46
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 15.97,
    y: 46
  }, "\xE1pida "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 85.31,
    y: 46
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 101.68,
    y: 46
  }, "dapt"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-67",
    x: 154.57,
    y: 46
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 168.03,
    y: 46
  }, "ci\xF3n"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 92
  }, "Sin E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-47",
    x: 56.08,
    y: 92
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 65.21,
    y: 92
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 74.23,
    y: 92
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 88.42,
    y: 92
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 97.44,
    y: 92
  }, "es"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 138
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-65",
    x: 16.48,
    y: 138
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 23.41,
    y: 138
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.34,
    y: 138
  }, "o Ni"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 76.78,
    y: 138
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 89.16,
    y: 138
  }, "el"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 184
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 16.48,
    y: 184
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 28.23,
    y: 184
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 40.7,
    y: 184
  }, "AMENTE escalable"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 230
  }, "Ho"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 32.01,
    y: 230
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.07,
    y: 230
  }, "as"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 276
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-65",
    x: 16.48,
    y: 276
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 23.41,
    y: 276
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.34,
    y: 276
  }, "o (libe"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 101.73,
    y: 276
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 110.79,
    y: 276
  }, "a tiempo)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 322
  }, "$$")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(293.16 89.75)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.48,
    y: 0
  }, "ROCESO MAN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 193.7,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    x: 212.42,
    y: 0
  }, "AL")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(669.79 85.85)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sma"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 50.69,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 60.5,
    y: 0
  }, "t R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 92.46,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-66",
    x: 106.02,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 119.72,
    y: 0
  }, "der")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(295.05 522.31)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-63",
    x: 15.3,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 30.92,
    y: 0
  }, "J"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.44,
    y: 0
  }, "A "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-53",
    x: 62.42,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 76.86,
    y: 0
  }, "RODU"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 140.72,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 155.24,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-48",
    x: 167.6,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 174.08,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 188.7,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 195.26,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    x: 211.58,
    y: 0
  }, "AD")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(604.83 520.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 15.32,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 26.1,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 37.76,
    y: 0
  }, "A "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 58.74,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.18,
    y: 0
  }, "RODU"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 137.04,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 151.56,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-49",
    x: 163.92,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 170.4,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 185.02,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 191.58,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    x: 207.9,
    y: 0
  }, "AD")), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    y1: 150.17,
    x2: 563.58,
    y2: 150.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    y1: 196.64,
    x2: 563.58,
    y2: 196.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    y1: 243.1,
    x2: 563.58,
    y2: 243.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    y1: 289.57,
    x2: 563.58,
    y2: 289.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    y1: 336.04,
    x2: 563.58,
    y2: 336.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    y1: 382.5,
    x2: 563.58,
    y2: 382.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    y1: 428.97,
    x2: 563.58,
    y2: 428.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    y1: 475.43,
    x2: 563.58,
    y2: 475.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 577.37,
    y1: 150.17,
    x2: 872.43,
    y2: 150.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    y1: 103.7,
    x2: 563.58,
    y2: 103.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 577.37,
    y1: 103.7,
    x2: 872.43,
    y2: 103.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 577.37,
    y1: 196.64,
    x2: 872.43,
    y2: 196.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 577.37,
    y1: 243.1,
    x2: 872.43,
    y2: 243.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 577.37,
    y1: 289.57,
    x2: 872.43,
    y2: 289.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 577.37,
    y1: 336.04,
    x2: 872.43,
    y2: 336.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 577.37,
    y1: 382.5,
    x2: 872.43,
    y2: 382.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 577.37,
    y1: 428.97,
    x2: 872.43,
    y2: 428.97
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,128.34c0,6.03-4.89,10.92-10.92,10.92-6.03,0-10.92-4.89-10.92-10.92s4.89-10.92,10.92-10.92c6.03,0,10.92,4.89,10.92,10.92ZM3.14,128.34c0,7.42,6.02,13.44,13.44,13.44,7.42,0,13.44-6.02,13.44-13.44s-6.02-13.44-13.44-13.44-13.44,6.02-13.44,13.44ZM15.32,121.2v7.14c0,.42.21.81.56,1.05l5.04,3.36c.58.39,1.36.23,1.75-.35s.23-1.36-.35-1.75l-4.48-2.98v-6.47c0-.7-.56-1.26-1.26-1.26s-1.26.56-1.26,1.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.53,299.24c.31.31.45.85.49,1.29.24,3.03-.18,6.36,0,9.42-.36,1.36-1.78,1.94-2.97,1.09s-1.01-1.18-1.49-1.5-.51.09-.72.27c-1.25,1.05-2.39,2.65-3.66,3.68-.76.62-1.5.72-2.41.33s-2.97-2.66-3.46-3.32c-.78-1.05-.49-2.07.27-2.99,1.14-1.36,2.72-2.54,3.88-3.91.07-.27-1.16-1.29-1.4-1.56-1.16-1.41-.53-3.04,1.27-3.26,2.88.18,6.02-.22,8.86,0s1.05.18,1.36.49l-.02-.02ZM29.19,300.56h-8.86c-.02.14,0,.22.09.33.43.67,1.99,1.67,2.23,2.39s-.07.6-.29.91c-1.05,1.41-3.23,3.01-4.42,4.39s-.4.6-.13,1.01,1.96,2.1,2.37,2.46.63.25.92.04l4.66-4.68c.18-.2.42-.25.67-.22s1.11.83,1.36,1.09,1.07,1.27,1.3,1.32l.18-.09v-8.72s-.13-.14-.09-.22v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.21,315.3c1.12,1.25,1.74,2.1.45,3.66-.53.63-3.82,3.62-3.9,3.97s1.25,1.38,1.49,1.69c1.09,1.41.2,2.99-1.49,3.14-2.86.25-6.05-.2-8.95,0-.91-.02-1.61-.78-1.67-1.67.2-3.01-.25-6.36,0-9.33.25-2.97,1.3-1.85,2.45-1.54s1.94,1.96,2.37,1.85c1.38-1.14,2.56-2.77,3.91-3.88,2.23-1.81,3.9.54,5.33,2.14v-.02ZM3.89,317.11v8.7l.13.14h8.9c.04-.16-.07-.18-.13-.27-.51-.67-1.67-1.45-2.08-2.08s-.24-.58-.14-.85l4.93-5.13-.05-.6c-.67-.45-2.19-2.65-2.88-2.74s-.27.04-.38.13l-4.73,4.71-.72.22c-.42.02-2.61-2.56-2.77-2.45.02.09-.09.18-.09.22h.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.62,437.3c.89,0,1.62.72,1.62,1.62v1.8c.08.01.16.02.24.04.02,0,.04,0,.06.01l2.43.44c.88.16,1.46,1.01,1.3,1.88-.16.87-1.01,1.46-1.88,1.3l-2.4-.44c-1.58-.23-2.98-.08-3.96.31s-1.37.92-1.47,1.42c-.1.54-.03.84.06,1.03.09.2.28.42.65.67.82.54,2.09.89,3.72,1.33l.15.04c1.45.38,3.21.85,4.53,1.71.72.47,1.39,1.11,1.81,2,.43.9.52,1.92.32,2.99-.35,1.92-1.67,3.2-3.32,3.88-.69.28-1.45.46-2.24.56v1.69c0,.89-.72,1.62-1.62,1.62s-1.62-.72-1.62-1.62v-1.76s-.05,0-.07-.01h-.01c-1.23-.19-3.26-.72-4.62-1.33-.81-.36-1.18-1.32-.82-2.13s1.32-1.18,2.13-.82c1.06.47,2.79.93,3.8,1.09,1.61.24,2.94.1,3.84-.27.85-.35,1.24-.85,1.35-1.46.1-.54.02-.84-.07-1.03-.1-.2-.28-.42-.66-.67-.83-.54-2.1-.89-3.74-1.33l-.14-.04h0c-1.44-.39-3.21-.86-4.52-1.72-.72-.47-1.39-1.11-1.81-2-.42-.9-.51-1.92-.31-2.99.36-1.93,1.81-3.18,3.45-3.84.67-.27,1.41-.45,2.18-.56v-1.78c0-.89.72-1.62,1.62-1.62Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.85,372.5c-.21-.05.02-.64.03-.82.03-.29,0-.6,0-.89h12.11c.65-.1,1.2-.41,1.44-1.05s.15-.58.15-.62v-13.66l-.12-.14h-6.17c-.84,0-2.27-1.24-2.27-2.1v-6.36l-.12-.14h-7.03c-.14,0-.64.24-.77.34-1.2.89-.57,3.49-.72,4.81-.6-.09-1.08.12-1.63.34v-4.33c0-.07.27-.84.33-.96.58-1.22,1.94-1.84,3.23-1.92,2.25-.15,5.81-.15,8.06,0,.88.07,1.36.27,2.01.82,2.18,1.82,4.14,4.41,6.29,6.32.29.4.53.82.57,1.32v16.15c-.12,1.32-1.84,2.89-3.13,2.89h-12.25l-.02-.02ZM20.65,347.04c-.22,1.48,0,4.07,0,5.67s.4.89.64.89h6.22c0-.19-.14-.34-.26-.48-.98-1.12-2.35-2.27-3.44-3.35-.84-.82-1.75-1.92-2.59-2.68s-.31-.17-.45-.29c-.03,0-.12.19-.12.21v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2,366.07c-.1.14-.1.29-.1.45-.12,1.65.19,3.64,0,5.24-.22,1.86-2.66-.52-3.38-.82-.29,0-1.86,1.37-2.35,1.51-.62.17-.98-.27-1.03-.86-.15-1.72.14-3.66,0-5.41-.46-.33-1.12-.29-1.56-.76s-.4-1.08-.64-1.6-.7-.65-.91-.98-.34-.81-.29-1.32.29-.82.29-1.13c0-.67-.48-.91-.21-1.89s.86-.93,1.1-1.39.1-1.15.67-1.67c.57-.52,1.15-.4,1.65-.65s.58-.64.88-.84.79-.43,1.22-.4c.43.03.98.33,1.2.33s1-.34,1.46-.34,1.03.36,1.37.69.29.48.46.57c.55.27,1.19.1,1.75.74s.36,1.15.62,1.61.93.58,1.12,1.46-.22,1.17-.22,1.77c0,.88.64,1.24.02,2.34s-.74.69-.91.98-.17.82-.34,1.2c-.34.74-1.08.98-1.82,1.13l-.03.05ZM12.51,356.71c-.46-.12-.89-.19-1.32-.43s-1-.91-1.12-.94c-.21-.05-.65.21-.93.24s-.48.03-.69,0c-.36-.03-.76-.27-1.01-.26s-.4.34-.6.52-.41.34-.58.45c-.31.17-1.15.34-1.25.45s-.31,1.06-.5,1.39-.91.86-.93,1.1.31.81.31,1.2-.26.94-.26,1.44c.27.45.72.64.98,1.17s.21,1.05.34,1.2.93.19,1.32.4.94.98,1.25.98.84-.36,1.2-.36,1.01.4,1.36.33c.43-.24.62-.72,1.1-.96s1.15-.22,1.32-.4.21-.94.36-1.25c.15-.31,1.03-1.1,1.03-1.25-.46-.93-.29-1.7-.02-2.65-.31-.4-.74-.62-.98-1.08s-.22-.88-.38-1.29l-.02.02ZM10.47,367.34c-.58.19-1.27-.36-1.75-.34s-1.1.5-1.61.36l-.14.12v2.32s.1.22.12.21c.43-.21,1.19-.94,1.63-.94s1.15.72,1.58.91l.17-.09s0-2.54,0-2.54Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.08,207.67c5.82.75,10.4,5.26,11.12,11.12.26.38,1.88-.3,2.25,1.03.13.43.13.66-.06,1.07-.53,1.15-2.05.56-2.23.84-.66,5.76-5.29,10.44-11.08,11.08-.21.38-.08.83-.13,1.24-.21,1.52-2.5,1.6-2.7-.09s.08-.98-.09-1.11c-5.82-.71-10.36-5.28-11.1-11.1-.15-.23-1.43.13-2.01-.53s-.47-.94-.24-1.52c.45-1.16,1.97-.53,2.22-.9s.32-1.56.43-1.97c1.41-5.03,5.58-8.39,10.7-9.14.24-.21-.13-1.35.47-1.95s1.07-.49,1.61-.23c1.15.54.49,1.92.83,2.22l.02-.06ZM15.24,210.6c-4.3.41-7.79,3.98-8.34,8.24.71.24,1.63-.06,2.31.19.96.36,1.05,1.97.17,2.42s-.6.21-.64.21h-1.82c.54,3.81,3.42,7.25,7.21,8.11.17.04,1.13.28,1.13,0v-1.69c0-.3.43-.92.71-1.07.73-.38,2.01.11,2.01.98v1.78c0,.06.17.21.28.19.26,0,1-.23,1.28-.3,3.61-1.09,6.27-4.26,6.76-7.98h-1.82c-.68,0-1.3-.79-1.26-1.45.09-1.76,1.92-1.11,3.08-1.37-.47-3.68-2.99-6.72-6.5-7.87-.23-.08-1.82-.62-1.82-.23v1.88c0,.13-.38.71-.51.81-.45.32-1.24.32-1.69,0s-.51-.75-.51-.9v-1.92l-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.52,218.41c.64-.04,1.41.38,1.69.98.94,1.93-1.45,3.64-2.89,2.23-1.16-1.13-.43-3.14,1.2-3.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.25,267.24c-.12-1.49-.78-2.66-1.8-3.2-.23-.12-1.16-.45-1.32-.47h-2.2s-.06-.03-.06-.03c-.31-.16-.31-.43-.31-.58l-.11-4.88c-.61-3.05-3.09-5.24-6.31-5.54-3.23-.3-6.06,1.39-7.24,4.31-.87,2.14-.52,6.05-.52,6.09v.03s0,.03,0,.03c-.03.19-.16.39-.2.44l-.08.08-.15.05h-2.05c-1.29,0-2.9,1.5-3.07,2.86l-.02,12c.15,1.72,1.71,3.09,3.55,3.09,1.12-.06,2.27-.08,3.43-.08,1.78,0,3.59.05,5.36.11,3.16.09,6.43.19,9.51-.02,2.14-.15,3.41-1.46,3.57-3.67-.09-1.61-.03-3.34.02-5.02.06-1.86.12-3.79-.02-5.59ZM12.3,256.87c1.16-1.85,3.35-2.64,5.56-2.01,2.2.63,3.62,2.46,3.62,4.66v3.76l-.33.29h-9.29l-.06-.03c-.24-.12-.31-.4-.29-.6-.17-1.32-.11-4.64.81-6.07ZM27.05,272.74c-.06,1.71-.13,3.49-.01,5.13-.02.39-.11.87-.4,1.16h0c-.1.1-.23.16-.34.21l-.12.06h-.07l-18.95.04s-.02,0-.04,0c-.77,0-1.2-.72-1.23-1.44h.05s0-.02,0-.04h-.04s.04,0,.04,0c-.07-.52-.07-1.85-.06-5.3,0-2.67.01-5.34.01-5.34.07-.92.48-1.36,1.33-1.45h18.46c.85.06,1.28.53,1.36,1.42.16,1.78.08,3.69.01,5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.04,171.17h.45c.7,0,1.26-.56,1.26-1.26v-6.71c0-.51-.3-.97-.78-1.16s-1.01-.09-1.37.27l-2.18,2.18c-4.59-4.54-11.99-4.52-16.56.05-4.59,4.59-4.59,12.03,0,16.61s12.03,4.59,16.61,0c.66-.66.66-1.72,0-2.38s-1.72-.66-2.38,0c-3.28,3.28-8.59,3.28-11.87,0s-3.28-8.59,0-11.87,8.53-3.28,11.82-.05l-2.16,2.16c-.36.36-.47.9-.27,1.37s.66.78,1.16.78h6.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.77,401.95l-7.01-9.51c-.16-.22-.41-.35-.68-.35h-15.01c-.27,0-.52.13-.68.35l-7.01,9.51c-.24.32-.22.77.05,1.07l14.51,16.01c.33.36.94.35,1.25,0l14.51-16.01c.27-.3.29-.75.05-1.07ZM24.57,393.79l-6.99,7.43-6.99-7.43h13.99ZM9.52,395.12l6.11,6.49H4.74l4.78-6.49ZM17.58,417.22l-12.61-13.92h25.22l-12.61,13.92ZM19.53,401.61l6.11-6.49,4.78,6.49h-10.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M640.25,53.98h-39.58c-2.29,0-4.14-1.21-4.14-2.7V17.65c0-1.49,1.85-2.7,4.14-2.7h39.58c2.29,0,4.14,1.21,4.14,2.7v33.63c0,1.49-1.86,2.7-4.14,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M691.65,32.05c0,17.7-13.46,32.05-30.06,32.05s-30.06-14.35-30.06-32.05S644.99,0,661.59,0s30.06,14.35,30.06,32.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M611.9,25.71h30.22c1.57,0,3-.93,3.72-2.4,3.05-6.26,9.27-10.51,16.4-10.35,9.48.21,17.29,8.34,17.65,18.39.39,10.91-7.83,19.89-18.03,19.89-.52,0-1.03-.02-1.54-.07-2.47-.22-4.6,1.8-4.6,4.43v29.52c0,2.43-1.86,4.41-4.15,4.41h-39.67c-2.29,0-4.15-1.97-4.15-4.41V30.12c0-2.43,1.86-4.41,4.15-4.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M650.89,32.74c0,2.43.77,4.68,2.07,6.51l-6.54,6.72c-.65.66-.65,1.74,0,2.4s1.7.66,2.34,0l6.54-6.72c1.78,1.34,3.97,2.12,6.34,2.12,5.94,0,10.75-4.94,10.75-11.03s-4.81-11.03-10.75-11.03-10.75,4.94-10.75,11.03h0ZM661.64,40.38c-4.08,0-7.44-3.45-7.44-7.64s3.36-7.64,7.44-7.64,7.44,3.45,7.44,7.64-3.36,7.64-7.44,7.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M630.42,57.22h-12.19c-1.67,0-3.03-1.45-3.03-3.23s1.36-3.23,3.03-3.23h12.19c1.67,0,3.03,1.45,3.03,3.23s-1.36,3.23-3.03,3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M630.42,43.74h-12.19c-1.67,0-3.03-1.45-3.03-3.23s1.36-3.23,3.03-3.23h12.19c1.67,0,3.03,1.45,3.03,3.23s-1.36,3.23-3.03,3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M642.45,69.88h-24.23c-1.67,0-3.03-1.45-3.03-3.23s1.36-3.23,3.03-3.23h24.23c1.67,0,3.03,1.45,3.03,3.23s-1.36,3.23-3.03,3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M642.45,82.57h-24.23c-1.67,0-3.03-1.45-3.03-3.23s1.36-3.23,3.03-3.23h24.23c1.67,0,3.03,1.45,3.03,3.23s-1.36,3.23-3.03,3.23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuadroL);
export default __webpack_public_path__ + "static/media/cuadroL.fd75232707214556998de2c2023f2c22.svg";
export { ForwardRef as ReactComponent };